import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WhatsAppConfigCreateRequestDTO, WhatsAppConfigEmbeddedSignupRequestDTO, WhatsappConfigDeleteRequestDTO, WhatsAppConfigDTO, WhatsAppConfigList, WhatsAppConfigReadAllPaginatedRequestDTO, WhatsappConfigReadByIdRequestDTO, WhatsappConfigUpdateRequestDTO } from './whatsapp-config.interface';
import { Observable } from 'rxjs';
import { WhatsAppConfig_create, WhatsAppConfig_delete, WhatsAppConfig_embeddedSignup, WhatsAppConfig_readAll, WhatsAppConfig_readAllPaginated, WhatsAppConfig_readById, WhatsAppConfig_update } from 'src/app/GlobalVariables';
import { PaginatedDTO } from 'src/app/Common/common.interface';

@Injectable({
  providedIn: 'root'
})
export class WhatsappConfigService {

  constructor() { }

  http = inject(HttpClient)

  WhatsAppConfig_create(data: WhatsAppConfigCreateRequestDTO): Observable<WhatsAppConfigDTO> {
    return this.http.post<WhatsAppConfigDTO>(WhatsAppConfig_create, data);
  }

  WhatsAppConfig_update(data: WhatsappConfigUpdateRequestDTO): Observable<WhatsAppConfigDTO> {
    return this.http.post<WhatsAppConfigDTO>(WhatsAppConfig_update, data);
  }
  WhatsAppConfig_readById(data: WhatsappConfigReadByIdRequestDTO): Observable<WhatsAppConfigDTO> {
    return this.http.post<WhatsAppConfigDTO>(WhatsAppConfig_readById, data);
  }
  WhatsAppConfig_readAll(): Observable<WhatsAppConfigList> {
    return this.http.get<WhatsAppConfigList>(WhatsAppConfig_readAll);
  }
 WhatsAppConfig_readAllPaginated(data: WhatsAppConfigReadAllPaginatedRequestDTO): Observable<WhatsAppConfigList> {
  return this.http.post<WhatsAppConfigList>(WhatsAppConfig_readAllPaginated,data);
}
  WhatsAppConfig_embeddedSignup(data: WhatsAppConfigEmbeddedSignupRequestDTO): Observable<WhatsAppConfigDTO> {
    return this.http.post<WhatsAppConfigDTO>(WhatsAppConfig_embeddedSignup, data);
  }
  WhatsAppConfig_delete(data: WhatsappConfigDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(WhatsAppConfig_delete, data);
  }

}
